import React, {FC, useContext} from "react"
import Input from "@irati/ui/src/FormItem/Input"
import {injectIntl, InjectIntl} from "@irati/utils/lang"
import AddressFormContext from "../../../utils/addressFormContext"

interface Props extends InjectIntl {}

const AddressTwo: FC<Props> = ({formatMessage}) => {
  const {shippingAddress, onFieldChange} = useContext(AddressFormContext)

  return (
    <Input
      label={formatMessage({id: "flexiRewards.merchandise.checkout.form.addressLine2"})}
      name={formatMessage({id: "flexiRewards.merchandise.checkout.form.addressLine2"})}
      value={shippingAddress.address2}
      onChange={(v) => onFieldChange({address2: v})}
    />
  )
}

export default injectIntl(AddressTwo)
